export const Backgrounds = {
  Black: 1,
  White: 2,
  Skybox: 3,
}
